var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit-header-block container"},[_c('h1',{staticClass:"benefit-header-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"benefit-header-description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }